// extracted by mini-css-extract-plugin
module.exports = {"main":"StuffSlider_main__Mga7o","title":"StuffSlider_title__avk_o","slider":"StuffSlider_slider__PKpXi"};